import React from 'react';

const CGV: React.FC = () => {
  return (
    <div className="bg-white py-16 px-4 sm:px-6 lg:px-8 lg:py-24">
      <div className="max-w-3xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900">
            Conditions Générales de Vente
          </h1>
          <p className="mt-2 text-lg text-gray-600">
            En vigueur au 11/07/2025
          </p>
        </div>

        <div className="mt-12 space-y-12 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900">1. Objet</h2>
            <p className="mt-2">
              Les présentes Conditions Générales de Vente (CGV) déterminent les droits et obligations des parties dans le cadre de la vente en ligne des services proposés par api100.io, une plateforme opérée par Global Gestion Sàrl (Suisse).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">2. Identification de l’éditeur</h2>
            <p className="mt-2">
              Global Gestion Sàrl<br />
              Route de Collex 22D, 1294 Genthod, Suisse<br />
              ✉️ <a href="mailto:contact@api100.io" className="text-blue-600 hover:underline">contact@api100.io</a><br />
              ☎️ +41 58 332 23 70
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">3. Description des services</h2>
            <p className="mt-2">
              api100.io propose un service de reverse proxy sécurisé permettant de connecter des API ou des applications locales au cloud sans ouverture de ports, avec chiffrement de bout en bout.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">4. Prix</h2>
            <p className="mt-2">
              Les prix sont affichés en francs suisses (CHF) et s’entendent toutes taxes comprises (TTC). L’éditeur se réserve le droit de modifier ses tarifs à tout moment. Les utilisateurs en seront informés par email ou via l’interface.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">5. Abonnement</h2>
            <p className="mt-2">
              Le service fonctionne par abonnement mensuel sans engagement, reconduit automatiquement. Le client peut résilier à tout moment depuis son espace personnel. La résiliation prend effet à la fin de la période en cours.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">6. Modalités de paiement</h2>
            <p className="mt-2">
              Le paiement s’effectue par carte bancaire via une plateforme sécurisée. Aucun accès aux coordonnées bancaires n’est conservé par l’éditeur.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">7. Obligations et responsabilité</h2>
            <p className="mt-2">
              Global Gestion Sàrl s’engage à fournir un service conforme à sa description, dans les meilleures conditions possibles de sécurité et de disponibilité. L’utilisateur reste responsable de l’usage qu’il fait du service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">8. Données</h2>
            <p className="mt-2">
              Aucun contenu de requêtes n’est stocké. Seules des données techniques anonymes (statistiques de trafic) sont collectées dans le respect de la LPD suisse et du RGPD.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">9. Droit applicable et juridiction</h2>
            <p className="mt-2">
              Les présentes CGV sont soumises au droit suisse. Tout litige sera porté devant les tribunaux du canton de Genève, sous réserve des dispositions légales impératives.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGV;
